import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvanoRadiobuttonComponent } from './avano-radiobutton.component';

@NgModule({
  imports: [CommonModule],
  exports: [AvanoRadiobuttonComponent],
  declarations: [AvanoRadiobuttonComponent]
})
export class AvanoRadiobuttonModule {}
